import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <section className="section">
      <div className="wrap">
        <p className="eyebrow">404</p>
        <h1>There's nothing at this address.</h1>
        <p>
          <Link to="/">Back to the home page</Link>
        </p>
      </div>
    </section>
  )
}
